<template>
  <div class="about">


<div class="main-records-wrapper">

<div class="all-records-wrapper">
  <h1 class="record-title"><span>All-Time Passing Yards</span></h1>
  <div class="record-wrapper brees-wrapper">
  <div class="record-photo saints"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brees-hs.png' alt='Drew Brees Headshot'></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">80,358</div>
</div>
<!-- <div class="record-wrapper">
  <div class="record-photo patriots"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brady-hs.png' alt='Tom Brady Headshot'></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">79,204</div>
</div>
<div class="record-wrapper">
  <div class="record-photo colts"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/manning-hs.png' alt='Peyton Manning Headshot'></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">71,940</div>
</div>
<div class="record-wrapper">
  <div class="record-photo packers"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/favre-hs.png' alt='Brett Favre Headshot'></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">71,838</div>
</div>
<div class="record-wrapper">
  <div class="record-photo dolphins"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/marino-hs.png' alt='Dan Marino Headshot'></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">61,361</div>
</div> -->

</div>

<div class="all-records-wrapper">
  <h1 class="record-title"><span>All-Time Passes Completed</span></h1>
<div class="record-wrapper brees-wrapper">
  <div class="record-photo saints"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brees-hs.png' alt='Drew Brees Headshot'></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">7,142</div>
</div>
<!-- <div class="record-wrapper">
  <div class="record-photo patriots"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brady-hs.png' alt='Tom Brady Headshot'></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">6,778</div>
</div>
<div class="record-wrapper">
  <div class="record-photo packers"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/favre-hs.png' alt='Brett Favre Headshot'></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">6,300</div>
</div>
<div class="record-wrapper">
  <div class="record-photo colts"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/manning-hs.png' alt='Peyton Manning Headshot'></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">6,125</div>
</div>
<div class="record-wrapper">
  <div class="record-photo dolphins"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/marino-hs.png' alt='Dan Marino Headshot'></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">4,967</div>
</div> -->
</div>


<div class="all-records-wrapper">
  <h1 class="record-title"><span>All-Time Passing TDs</span></h1>
<!-- <div class="record-wrapper">
  <div class="record-photo patriots"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brady-hs.png' alt='Tom Brady Headshot'></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">581</div>
</div> -->
<div class="record-wrapper brees-wrapper">
  <div class="record-photo saints"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brees-hs.png' alt='Drew Brees Headshot'></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">571</div>
</div>

<!-- <div class="record-wrapper">
  <div class="record-photo colts"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/manning-hs.png' alt='Peyton Manning Headshot'></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">539</div>
</div>
<div class="record-wrapper">
  <div class="record-photo packers"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/favre-hs.png' alt='Brett Favre Headshot'></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">508</div>
</div>
<div class="record-wrapper">
  <div class="record-photo dolphins"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/marino-hs.png' alt='Dan Marino Headshot'></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">420</div>
</div> -->

</div>

<div class="all-records-wrapper">
  <h1 class="record-title"><span>All-Time Passing Attempts</span></h1>
  <!--<div class="record-summary">
    Brees broke Sam Bradford's single-season record (71.6) for completion percentage this season at 72 percent, and he now has three of the four most accurate seasons (2011, 71.2, third; 2009, 70.6, fourth).
  </div>-->
<!-- <div class="record-wrapper">
  <div class="record-photo patriots"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brady-hs.png' alt='Tom Brady Headshot'></div>
  <div class="record-name">Tom Brady</div>
  <div class="record-value">10,598</div>
</div> -->

<div class="record-wrapper brees-wrapper">
  <div class="record-photo saints"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/brees-hs.png' alt='Drew Brees Headshot'></div>
  <div class="record-name">Drew Brees</div>
  <div class="record-value">10,551</div>
</div>

  <!-- <div class="record-wrapper"><div class="record-photo packers"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/favre-hs.png' alt='Brett Favre Headshot'></div>
  <div class="record-name">Brett Favre</div>
  <div class="record-value">10,097</div>
</div>
<div class="record-wrapper">
  <div class="record-photo colts"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/manning-hs.png' alt='Peyton Manning Headshot'></div>
  <div class="record-name">Peyton Manning</div>
  <div class="record-value">9,380</div>
</div>
<div class="record-wrapper">
  <div class="record-photo dolphins"><img src='https://s3-us-west-2.amazonaws.com/s.cdpn.io/500458/marino-hs.png' alt='Dan Marino Headshot'></div>
  <div class="record-name">Dan Marino</div>
  <div class="record-value">8,358</div>
</div> -->

</div>


</div>

<div class="fact-wrapper">
  <div class="fact-headline">Where Brees Ranks in NFL History</div>
  <div class="fact-sub-headline">(The following stats are from the end of the 2019 season)</div>
  <div class="flex-table-wrapper">
    <div class="flex-table-row flex-table-header">
      <div class="flex-table-cell"><span>Stat Category</span></div>
      <div class="flex-table-cell"><span>No.</span></div>
      <div class="flex-table-cell"><span>Active Rank</span></div>
      <div class="flex-table-cell"><span>All-Time</span></div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Attempts</div>
      <div class="flex-table-cell">10,161</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">2</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Completions</div>
      <div class="flex-table-cell">6,867</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Passing Yards</div>
      <div class="flex-table-cell">77,416</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Passing TDs</div>
      <div class="flex-table-cell">547</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Passer Rtg. (min 1,500 att)</div>
      <div class="flex-table-cell">98.4</div>
      <div class="flex-table-cell">3</div>
      <div class="flex-table-cell">3</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">300-yard passing games</div>
      <div class="flex-table-cell">120</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Games with 4+ Passing TDs</div>
      <div class="flex-table-cell">36</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Games with 5+ Passing TDs</div>
      <div class="flex-table-cell">11</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">3,000-yard Passing Seasons</div>
      <div class="flex-table-cell">16</div>
      <div class="flex-table-cell">t1</div>
      <div class="flex-table-cell">t2</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">4,000-yard Passing Seasons</div>
      <div class="flex-table-cell">12</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">2</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">5,000-yard Passing Seasons</div>
      <div class="flex-table-cell">5</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Seasons with 25+ Passing TDs</div>
      <div class="flex-table-cell">14</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">t2</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Seasons with 30+ Passing TDs</div>
      <div class="flex-table-cell">10</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">1</div>
    </div>
    <div class="flex-table-row">
      <div class="flex-table-cell">Game Winning Drives</div>
      <div class="flex-table-cell">50</div>
      <div class="flex-table-cell">1</div>
      <div class="flex-table-cell">2</div>
    </div>
  </div>


<div class="wrapper-go-to-image-link">
<router-link to="/year/intro">
<img :src="require('@/assets/go-to-years.png')" alt="Over the Years Page">
</router-link>
</div>


</div>

<div id="by-the-numbers">

<div class="fact-headline">Drew Brees By The Numbers</div>
<div class="fact-sub-headline">(The following stats are from the end of the 2019 season)</div>
<div class="all-numbers-wrapper">

<div class="number-wrapper">
  <div class="the-number">4</div>
  <p>Brees (2011 and 2012), Dan Marino (Miami in 1984 and 1986) Peyton Manning (Denver in 2013 and Indianapolis in 2004), and Aaron Rodgers (Green Bay in 2011 and 2016) are the only four players to throw for 40 or more touchdowns twice.</p>

  <p>NFL-record number of consecutive games that Brees threw for 350 yards in 2011.</p>

  <p>Also the number of undrafted players (wide receivers Austin Carr, Tommylee Lewis, tight end Dan Arnold and wide receiver Keith Kirkwood) that caught touchdown passes from Brees, November 22, 2018 vs. Atlanta, the first time that happened in NFL history.</p>

  <p>Career-high number of rushing touchdowns in 2018.</p>

  <p>Also with his performance in the last four games of 2019, Brees became only the fourth player in NFL record books with four consecutive games with at least three touchdowns passes and zero interceptions in a single season.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">5</div>
  <p>NFC Offensive Player of the Month awards won by Brees in his Saints career, including this past December, the most monthly conference awards won by a Saints player.</p>
  <p>National Football League-record number of seasons (2008, 2011-13, 2016) that Brees has thrown for over 5,000 yards.</p>
  <p>Brees’ 434 postseason completions also ranked fifth in NFL records.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">6</div>
  <p>In the postseason, Brees’ passing yardage (4,967) and touchdown passes (34) both rank sixth in National Football League records.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">7</div>
  <p>In the postseason, Brees’ passing yardage (4,967) and touchdown passes (34) both rank sixth in National Football League records.</p>
  <p>The league-record number of times Brees has led the league in passing yardage.</p>
  <p>Also the career-high and NFL-record tying number of touchdown passes he threw against the New York Giants on Nov. 1, 2015.</p>
  <p>Also the NFL-record number of regular season contests where Brees has thrown five touchdowns and zero interceptions, after he did so on December 8 vs. San Francisco.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">8</div>
  <p> National Football League-record number of times Brees reached the 350-yard passing mark in 2011. He tossed for 370 yards in the season-opening win vs. Houston in the Monday night season-opening win on September 9 and for 373 yards in the October 27 win over the Arizona Cardinals.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">9</div>
  <p>National Football League-record stretch of consecutive games with at least 300 yards passing, which he’s accomplished twice.</p>
  <p>Brees’ nine-game winning streak (11/24/08-9/30/13) as a starter on Monday Night Football is tied for second all-time. </p>
</div>
<div class="number-wrapper">
  <div class="the-number">10</div>
  <p>The National Football League-record number of seasons overall that Brees has thrown for at least 30 touchdowns.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">11</div>
  <p>The number of consecutive seasons Brees threw 25 touchdowns from 2006-16, making him only the second player in history to do so, joining Manning (13, 1998-2010).</p>
</div>
<div class="number-wrapper">
  <div class="the-number">12</div>
  <p> The team record number of seasons that Brees has been selected to the Pro Bowl as a Saint.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">13</div>
  <p>Including once with the San Diego Chargers in 2004, the number of times Brees has been selected to the Pro Bowl.</p>
  <p>The number of seasons, all consecutive Brees has tossed for at least 4,000 yards.</p>
  <p>Also, with 13 300-yard games in 2011, Brees set the NFL single-season record, surpassing the one he previously tied with 10 in 2008.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">14</div>
  <p>The seasons Brees has thrown 25 or more touchdowns, tied for second in NFL record books with Tom Brady (14) and behind Manning (16).</p>
</div>
<div class="number-wrapper">
  <div class="the-number">16</div>
  <p>National Football League-record number of regular season contests where Brees has thrown for at least 400 yards.</p>
  <p>In 2018, Brees became the fourth player in National Football League records to have 16 3,000-yard passing seasons, joining Favre (18) and Brady (17) and tied with Manning.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">19</div>
  <p>Rushing touchdowns as a Saint, having surpassed Archie Manning for first place among Saints quarterbacks following his one-yard quarterback sneak on December 8
vs. San Francisco.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">23</div>
  <p>Club-record NFC Player of the Week awards won by Brees as a member of the Saints and the most conference Player of the Week honors since 2006, including Week 15
honors.</p>
  <p>Dec. 8 vs. San Francisco, Brees jumped over the pile for a one-yard touchdown in the second quarter to give him 23 career rushing touchdowns.</p>
  <p>Brees is ranked 23rd in NFL record books with 275 regular season appearances.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">24</div>
  <p>The NFL-record number of games with four touchdown passes and zero interceptions after his four touchdown, zero pick performance on December 16 vs. Indianapolis.</p>
</div>

<div class="number-wrapper">
  <div class="the-number">25</div>
  <p>Including his five-year tenure with the San Diego Chargers, his 25 conference Player of the Week awards ranks third all-time in National Football League record books behind Brady (28) and Manning (27).</p>
</div>
<div class="number-wrapper">
  <div class="the-number">36</div>
  <p>Regular season contests by Brees with at least four touchdown passes, surpassing Peyton Manning for first place in club record books on December 16 vs. Indianapolis.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">41</div>
  <p> Number of successful drives in the fourth quarter or overtime engineered by Brees for a touchdown or field goal in the regular season to lead the Saints to victory since joining the club in 2006, including two in 2019.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">45</div>
  <p>Consecutive regular season contests between 2012-15 with at least one touchdown pass, fifth-best in league history. The streak ended Nov, 29, 2015 at Houston. </p>
</div>
<div class="number-wrapper">
  <div class="the-number">54</div>
  <p>Consecutive regular season contests between 2009-12 with at least one touchdown pass, the longest streak in National Football League history, surpassing the record previously held by Johnny Unitas (47). It was set October 7, 2012 vs. San Diego. It ended November 29, 2012 at Atlanta</p>
</div>
<div class="number-wrapper">
  <div class="the-number">61</div>
  <p>National Football League-record number of games with at least 30 completions.</p>
  <p>Also, the NFL-record number of consecutive regular season contests where Brees threw at least 20 completions until October 13, 2013 at New England.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">67.6</div>
  <p>Career completion percentage, ranked first in National Football League record books.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">68.8</div>
  <p>Team-record completion percentage as a Saint, ranked first in the NFL during this 14-season period.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">69</div>
  <p>Players that Brees’ 544 career touchdown passes have gone to.</p>
  <p>October 27 vs. Arizona, RB Latavius Murray, signed by New Orleans as an unrestricted free agent in the offseason from the Vikings became the 69th player and
53rd Saint to catch a touchdown from Brees.</p>
</div>
<div class="number-wrapper">
  <div class="the-number">74.3</div>
  <p>National Football League-best completion percentage by Brees in 2019 </p>
</div>  
<div class="number-wrapper">
  <div class="the-number">74.4</div>
  <p>NFL-record completion percentage in 2018 by Brees that surpassed his record total of 72.0% in 2017.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">86</div>
  <p>Players who have caught a pass from Brees in the regular season, including himself off of deflections. Tight End Jared Cook and Murray, both 2019 unrestricted free agent acquisitions, undrafted rookie wide receiver/return specialist Deonte Harris, wide receiver Krishawn Hogan and fullback Ricky Ortiz, are the latest Saints to catch passes from Brees in 2019.</p>
</div>  
<div class="number-wrapper">
  <div class="the-number">96.7</div>
  <p>NFL-record completion percentage by Brees in the December 16 win over Indianapolis, when he fired on 29 of 30 throws.</p>
</div>  
<div class="number-wrapper">
  <div class="the-number">103.5</div>
  <p>Career passer rating indoors during the regular season, ranked fourth in the NFL All-time.</p>
</div>  
<div class="number-wrapper">
  <div class="the-number">113</div>
  <p>Club-record regular season contests by Brees with 300 yards or more passing as a Saint, the highest total since 2006. Brees has reached the 300-yard mark 120
times, ahead of Peyton Manning (93) for the most all-time. Brees tossed for 300 yards five times in 2019, including for 307 yards on December 16 vs. Indianapolis.</p>
</div>  
<div class="number-wrapper">
  <div class="the-number">117</div>
  <p>Regular season games by Brees as a Saint where he’s posted a passer rating of 100 or more (min. 10 attempts) including a 123.3 rating at Carolina in
the regular season finale, owning a 93-24 record in these contests. Overall, in his 19-year career, he has reached the milestone 132 times, eight times in 11 appearances in 2019.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">133</div>
  <p>Club-record regular season wins as a starter since signing with the club in 2006 as unrestricted free agent, making him the second-winningest signal-caller in the National Football League and most in the NFC over that period. Including the playoffs, Brees has compiled a 141-88 record as the Saints’ starter.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">163</div>
  <p>Regular season wins by Brees in his 19-year career with both New Orleans and the San Diego Chargers.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">165</div>
  <p>Regular season games Brees has with two or more touchdown passes in his 19-year career, the second-most by an active player behind New England Patriots signal-caller Tom Brady (169) and ranked third overall. Since signing with the Saints in 2006, Brees has 140 contests with multiple touchdown passes, first in the NFL.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">205</div>
  <p> Oct. 4, 2015 vs. Dallas, with an 80-yard touchdown pass to RB C.J. Spiller, Brees reached 400 touchdowns in his 205th career regular season game, the quickest in NFL history a player’s reached 400 touchdowns, eclipsing the record previously held by Peyton Manning (209).</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">216</div>
  <p>Nov. 18, 2018 vs. Philadelphia, Brees became the first player in franchise history to appear in 200 games for the club, having now appeared in 216, playing in 11 contests in 2019.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">240</div>
  <p>Regular season games it took Brees to reach 6,000 career completions, which occurred, Oct. 29, 2017 vs. Chicago, doing so 19 games sooner than Peyton Manning. </p>
</div> 
<div class="number-wrapper">
  <div class="the-number">269</div>
  <p> Regular season touchdown passes at the MercedesBenz Superdome by Brees, since he signed with the Saints in 2006, the most by a player at a specific stadium.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">467</div>
  <p>Touchdown passes as a Saint, first in club records and in the NFL during this period. With 547 career touchdown passes, he’s first all-time, becoming the league’s passing touchdown leader on Dec. 16 vs. Indianapolis.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">5,742</div>
  <p>Completions since signing with the Saints in 2006, the NFL’s highest total over this 14-season period.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">6,867</div>
  <p>Career completions total, ranked first in the NFL. Brees set the record on September 23, 2018 at Atlanta with a 17-yard completion to wide receiver Michael Thomas.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">65,068</div>
  <p> In the Dec. 29 regular season finale win at Carolina, Brees reached 65,000 yards as a Saint and wrapped up the regular season with 65,068.</p>
</div> 
<div class="number-wrapper">
  <div class="the-number">77,416</div>
  <p>Brees has an NFL-best 77,416 career passing
yards, first all-time. </p>
</div> 




  
</div>
  </div>





  </div>
</template>

<script>


import VideoBtn from '@/components/VideoBtn.vue';

export default {
  components: {
    VideoBtn
  },
  metaInfo: {
    title: 'Drew Brees All-Time Record Tracker',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    onShowModal(){
      this.showModal = true;
    }
}
}
</script>

<style>

.wrapper-go-to-image-link {
  margin:40px 0px;
}

.wrapper-go-to-image-link img {
  width:100%;
  max-width:526px;
}





 /* NEW STYLES */

@import url('https://fonts.googleapis.com/css?family=Poppins|Teko:400,700');

body {
  margin:0px;

}

.packers{
  background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/GB.svg);
    background-position: center center;
    background-size: 90%;
}
.saints{
  background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/NO.svg);
    background-position: center center;
    background-size: 120%;
}

.patriots{
  background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/TB.svg);
    background-position: center center;
    background-size: 90%;
}

.dolphins{
  background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/MIA.svg);
    background-position: center center;
    background-size: 90%;
}

.colts {
    background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/IND.svg);
    background-position: center center;
    background-size: 90%;
}

.main-records-wrapper {
  display:flex;
  flex-wrap:wrap;
  width:100%;
  justify-content:space-between;
  align-items:flex-end;
  background-color:#f4f4f4;
}

.all-records-wrapper {
    display: flex;
    flex-wrap:wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    background: #000000;
    width: 50%;
    box-shadow: 0px 0px 33px -11px black;
    padding: 20px 0px 20px 0px;
}

.record-wrapper {
  display:flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e4e4e4;
  height: 85px;
  width: 100%;
  max-width:900px;
  font-family: 'Teko', sans-serif;
  font-size: 30px;
  text-transform: uppercase;
  background-repeat: no-repeat;
  background-position: -8px center;
  background-size: 250px;
  box-shadow: inset 0px -3px 10px -3px black;
  color:#000;
background: rgb(255,255,255);
background: -moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(241,241,241,1) 50%, rgba(225,225,225,1) 51%, rgba(246,246,246,1) 100%); 
background: -webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(241,241,241,1) 50%,rgba(225,225,225,1) 51%,rgba(246,246,246,1) 100%);
background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(241,241,241,1) 50%,rgba(225,225,225,1) 51%,rgba(246,246,246,1) 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f6f6f6',GradientType=0 );
}


/*
.all-records-wrapper:nth-of-type(even) .record-wrapper {
  color:#fff;
background: rgb(173, 173, 173); 
background: -moz-linear-gradient(top, rgb(173, 173, 173) 0%, rgb(131, 131, 131) 50%, rgb(98, 98, 98) 51%, rgb(134, 134, 134) 100%); 
background: -webkit-linear-gradient(top, rgb(173, 173, 173) 0%,rgb(131, 131, 131) 50%,rgb(98, 98, 98) 51%,rgb(134, 134, 134) 100%); 
background: linear-gradient(to bottom, rgb(173, 173, 173) 0%,rgb(131, 131, 131) 50%,rgb(98, 98, 98) 51%,rgb(134, 134, 134) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f6f6f6',GradientType=0 ); 



}

 .brees-wrapper, .all-records-wrapper:nth-of-type(even) .brees-wrapper {
background: rgb(219,207,155); 
background: -moz-linear-gradient(top, rgba(219,207,155,1) 0%, rgba(211,188,141,1) 50%, rgba(191,169,128,1) 51%, rgba(211,188,141,1) 100%);
background: -webkit-linear-gradient(top, rgba(219,207,155,1) 0%,rgba(211,188,141,1) 50%,rgba(191,169,128,1) 51%,rgba(211,188,141,1) 100%); 
background: linear-gradient(to bottom, rgba(219,207,155,1) 0%,rgba(211,188,141,1) 50%,rgba(191,169,128,1) 51%,rgba(211,188,141,1) 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dbcf9b', endColorstr='#d3bc8d',GradientType=0 ); 
  color:#fff;
}


.brees-wrapper .record-value, .all-records-wrapper:nth-of-type(even) .brees-wrapper .record-value{
background: rgb(211,188,141); 
background: -moz-linear-gradient(top, rgba(211,188,141,1) 0%, rgba(191,169,128,1) 49%, rgba(211,188,141,1) 50%, rgba(219,207,155,1) 100%); 
background: -webkit-linear-gradient(top, rgba(211,188,141,1) 0%,rgba(191,169,128,1) 49%,rgba(211,188,141,1) 50%,rgba(219,207,155,1) 100%); 
background: linear-gradient(to bottom, rgba(211,188,141,1) 0%,rgba(191,169,128,1) 49%,rgba(211,188,141,1) 50%,rgba(219,207,155,1) 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d3bc8d', endColorstr='#dbcf9b',GradientType=0 ); 
}

.all-records-wrapper:nth-of-type(even) .record-value {
  color:#fff;
  
background: rgb(173, 173, 173); 
background: -moz-linear-gradient(top, rgb(173, 173, 173) 0%, rgb(131, 131, 131) 50%, rgb(98, 98, 98) 51%, rgb(134, 134, 134) 100%); 
background: -webkit-linear-gradient(top, rgb(173, 173, 173) 0%,rgb(131, 131, 131) 50%,rgb(98, 98, 98) 51%,rgb(134, 134, 134) 100%); 
background: linear-gradient(to bottom, rgb(134, 134, 134) 0%,rgb(98, 98, 98) 50%,rgb(131, 131, 131) 51%, rgb(173, 173, 173) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f6f6f6',GradientType=0 );

}


*/


 .brees-wrapper {
background: rgb(219,207,155); 
background: -moz-linear-gradient(top, rgba(219,207,155,1) 0%, rgba(211,188,141,1) 50%, rgba(191,169,128,1) 51%, rgba(211,188,141,1) 100%);
background: -webkit-linear-gradient(top, rgba(219,207,155,1) 0%,rgba(211,188,141,1) 50%,rgba(191,169,128,1) 51%,rgba(211,188,141,1) 100%); 
background: linear-gradient(to bottom, rgba(219,207,155,1) 0%,rgba(211,188,141,1) 50%,rgba(191,169,128,1) 51%,rgba(211,188,141,1) 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dbcf9b', endColorstr='#d3bc8d',GradientType=0 ); 
  color:#fff;
}

/*.brees-wrapper .record-value {
background: rgb(211,188,141); 
background: -moz-linear-gradient(top, rgba(211,188,141,1) 0%, rgba(191,169,128,1) 49%, rgba(211,188,141,1) 50%, rgba(219,207,155,1) 100%); 
background: -webkit-linear-gradient(top, rgba(211,188,141,1) 0%,rgba(191,169,128,1) 49%,rgba(211,188,141,1) 50%,rgba(219,207,155,1) 100%); 
background: linear-gradient(to bottom, rgba(211,188,141,1) 0%,rgba(191,169,128,1) 49%,rgba(211,188,141,1) 50%,rgba(219,207,155,1) 100%); 
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d3bc8d', endColorstr='#dbcf9b',GradientType=0 ); 
}
*/

.record-title {
    font-family: 'Teko', sans-serif;
    font-size: 60px;
    text-transform: uppercase;
    margin: 0px;
    width: 100%;
    margin: auto;
    text-align: center;
    color:white;
    /*background: rgb(246,246,246);
    background: -moz-linear-gradient(top, rgba(246,246,246,1) 0%, rgba(225,225,225,1) 49%, rgb(212, 212, 212) 50%, rgba(244, 244, 244) 100%);
    background: -webkit-linear-gradient(top, rgba(246,246,246,1) 0%,rgba(225,225,225,1) 49%,rgb(212, 212, 212) 50%,rgba(244, 244, 244) 100%);
    background: linear-gradient(to bottom, rgba(246,246,246,1) 0%,rgba(225,225,225,1) 49%,rgb(212, 212, 212) 50%,rgb(244, 244, 244) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f6f6f6', endColorstr='#ffffff',GradientType=0 );
    */
}


h1.record-title > span {
    position: relative;
    top: 4px;
    display: block;
    background: none;
    max-width: 100%;
    line-height: 80px;
}

.record-photo {
  align-self:center;
  height:100%;
  width: 25%;
  text-align: left;
  background-repeat: no-repeat;
}

.record-photo:after {
    content: '';
    width: 42px;
    background: #0000000d;
    position: absolute;
    font-size: 25px;
    position: relative;
    z-index: 1;
    height: 85px;
    right: 50%;
    display: block;
    float: right;
    transform: skewX(-12deg);
    top: 0;
}

.record-photo > img {
max-height: 85px;
    padding-top: 0px;
    padding-left: 1px;
    box-shadow: 22px 0px 40px -26px black;
  position: relative;
    z-index: 2;
}

.record-name {
    font-size:50px;
    line-height: 36px;
    position: relative;
    top: 5px;
    width: 50%;
    text-align: left;
}

.record-value {
  font-size: 40px;
    line-height: 68px;
    position: relative;
    top: 0px;
    width: 32%;
    border-radius: 12px;
    height: 65px;
    border-top-left-radius: 0px;
    border-bottom-right-radius: 0px;
    margin-right: 15px;
    box-shadow: 0px 0px 16px -5px #5b5b5bd4;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
   /* background: rgb(246,246,246);
    background: -moz-linear-gradient(top, rgba(246,246,246,1) 0%, rgba(225,225,225,1) 49%, rgba(241,241,241,1) 50%, rgba(255,255,255,1) 100%);
    background: -webkit-linear-gradient(top, rgba(246,246,246,1) 0%,rgba(225,225,225,1) 49%,rgba(241,241,241,1) 50%,rgba(255,255,255,1) 100%);
    background: linear-gradient(to bottom, rgba(246,246,246,1) 0%,rgba(225,225,225,1) 49%,rgba(241,241,241,1) 50%,rgba(255,255,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f6f6f6', endColorstr='#ffffff',GradientType=0 );
  */
}






.record-summary {
    font-family: 'Teko', sans-serif;
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    padding: 10px 30px;
}

.record-wrapper:first-of-type {
    border-top-right-radius: 19px;

}

.record-wrapper:last-of-type {

    border-bottom-left-radius: 19px;
}

.record-wrapper:last-of-type .record-photo > img {

    border-bottom-left-radius: 19px;
}




#by-the-numbers {
  padding:40px 0px;
background-color: #d3bc8c;  
}

.all-numbers-wrapper {
display:flex;
flex-wrap:wrap;
justify-content:space-around;
}

.number-wrapper {
  font-family: Teko;
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items: flex-start;
  flex-basis: 30%;
  margin-bottom:20px;
  text-align:left;
    background-color: #272727;
    color: white;

}

.the-number {
    font-size: 90px;
    line-height: 92px;
    background: #fff7e6;
    color: black;
    padding: 10px 20px 0px 20px;
}

.number-wrapper > p {
    font-size: 18px;
    line-height: 24px;
    margin-top: 0px;
    border-top: 2px solid #fff7e6;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    font-family: 'Poppins';
}




@media (max-width: 1825px) {

  
    .record-title {
    font-family: 'Teko', sans-serif;
    font-size: 42px;
    line-height: 42px;
    text-transform: uppercase;
    margin: 0px;
}

}

@media (max-width:1365px) {


.number-wrapper {
  flex-basis: 49%;
}

.number-wrapper > p {
    font-size: 16px;
    line-height: 22px;
}



}

@media (max-width: 1200px) {
.record-photo {
    width: 30%;
}
  
}

@media (max-width: 1000px) {
  .all-records-wrapper {
    width:50%;
  }
.record-wrapper {

  background-position: -65px center;
}

.record-title {
    font-size: 27px;
    line-height: 30px;
}


.record-name {
font-size:40px;
    position: relative;
    top: 6px;
}
.record-value {

    position: relative;
    top: 0px;
    height: 50px;
}

.record-summary {
    font-size: 18px;
    line-height: 24px;
    padding: 10px 25px;
}
  
  .record-photo:after {
width:24px;
    right: 30%;

}
  
}


@media (max-width:768px) {
.record-photo:after {
    width: 10px;
    right: 12%;
}

.record-title {
    font-size: 27px;
    line-height: 30px;
}


}

@media (max-width: 620px) {

  .number-wrapper {
  flex-basis: 100%;
}

.number-wrapper > p {
    font-size: 14px;
    line-height: 20px;
}

.the-number {
    font-size: 50px;
    line-height: 52px;
}

    .all-records-wrapper {
    width:100%;
  }

  .record-wrapper {
    height: 90px;
    background-position: -49px center;
    background-size: 150px;
}

  .record-name {
    font-size: 35px;
    line-height: 35px;
    position: relative;
    top: 4px;
}
.record-title {
    font-size: 20px;
}

h1.record-title > span {
    position: relative;
    top: 3px;
    display: block;
    background: none;
    max-width: 100%;
    line-height: 50px;
}
  
  .record-photo > img {
max-height: 90px;
    padding-top: 0px;
    padding-left: 1px;
    box-shadow: 22px 0px 40px -26px black;
}
  
  .record-photo:after {
    width: 27px;
    height: 90px;
    right: 46px;

}
  
  .record-value {
    font-size: 50px;
    height: 60px;
}
  
}

@media (max-width: 500px) {
  .record-wrapper {
    height: 60px;
}
  
  .record-photo {
    width: 20%;
}
  
  .record-photo > img {
    max-height: 60px;
    padding-top:0px;
}
  
.record-photo:after {
display:none;
}
  
  .record-value {
    font-size: 30px;
    height: 37px;
}

}



@media (max-width: 375px) {

.record-name {
    font-size: 26px;
    line-height: 24px;
    position: relative;
    top: 3px;
}
}



</style>


// WEBPACK FOOTER //
// src/views/Records.vue